module.exports = __webpack_public_path__ + "static/media/8x8no2.683bf727.jpg";